import styled from 'styled-components';
import TableOfContentSidebar from '@/components/TableOfContentSidebar';

export const PageContent = styled.div`
  display: flex;
`;

export const TopicArea = styled.div`
  width: 100%;
`;

export const PageGrid = styled.div`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-direction: row;
  }
`;

export const Sidebar = styled(TableOfContentSidebar)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    top: 67px;
  }
`;

export const Content = styled.div`
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: calc(100% - 284px);
  }
`;

export const NotesAndReviewBox = styled.div<{ hasReviews: boolean; isScreeningInterview: boolean }>`
  display: flex;
  flex-direction: ${(props) =>
    props.hasReviews && props.isScreeningInterview ? 'column-reverse' : 'column'};
`;

export const Divider = styled.div`
  margin: 24px 0;
  border-top: 1px solid ${(props) => props.theme.colors['neutral-30']};
`;

export const AIOverviewContainer = styled.div`
  border-radius: 8px;
  padding: 16px;
  background: ${(props) => props.theme.colors['secondary-20']};
  border: 1px solid ${(props) => props.theme.colors['primary-50']};
  margin-bottom: 24px;
`;

export const AIOverviewHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
  }
`;

export const AIOverviewTitle = styled.span`
  font-weight: 600;
  color: ${(props) => props.theme.colors['primary-80']};
`;

export const AIOverviewMeta = styled.span`
  color: ${(props) => props.theme.colors['neutral-80']};
  font-size: 14px;
`;

export const AIOverviewText = styled.p`
  margin: 12px 0 0;
  color: ${(props) => props.theme.colors['neutral-100']};
  white-space: pre-wrap;
  line-height: 1.5;
`;
